import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    setLoading(true);

    const result = await login(kullaniciAdi, sifre);
    setLoading(false);

    if (result.success) {
      if (result.rol === 'Admin') {
        navigate('/admin');
      } else if (result.rol === 'Garson') {
        navigate('/garson');
      } else if (result.rol === 'Kasa') {
        navigate('/kasa');
      } else if (result.rol === 'Mutfak') {
        navigate('/mutfak');
      } else {
        navigate('/');
      }
    } else {
      setHata(result.message || 'Giriş başarısız!');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-brand">
          <h1>☕ NEŞVE Cafe</h1>
          <p>Personel Girişi</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {hata && <div className="login-error">{hata}</div>}
          <div className="input-group">
            <label>Kullanıcı Adı</label>
            <input
              type="text"
              value={kullaniciAdi}
              onChange={(e) => setKullaniciAdi(e.target.value)}
              placeholder="Kullanıcı adınızı girin"
              required
            />
          </div>
          <div className="input-group">
            <label>Şifre</label>
            <input
              type="password"
              value={sifre}
              onChange={(e) => setSifre(e.target.value)}
              placeholder="Şifrenizi girin"
              required
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
        <button className="back-btn" onClick={() => navigate('/')}>← Ana Sayfa</button>
      </div>
    </div>
  );
};

export default LoginPage;
